import { Backdrop, Box, Button, CircularProgress, Fade, Modal, Typography } from "@mui/material";
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { useTranslation } from "react-i18next";
import DriveFileRenameOutlineOutlinedIcon from '@mui/icons-material/DriveFileRenameOutlineOutlined';
import { useState } from "react";
import DriverDropdown from "../../dropdowns/driverDropdown";
import PostStatusDropdown from "../../dropdowns/postRelated/postStatusDropdown";
import PostService from "../../../services/postService";
import ChangeStatusDropdown from "../../dropdowns/postRelated/changeStatusDropdown";


const UpdateMultiplePostModal = ({
    open,
    handleClose,
    setPopupMsg,
    setPopupType,
    setShowPopup,
    posts,
    type,
    updateType
}) => {
    const { t } = useTranslation();

    const [formValues, setFormValues] = useState({
        driverId: null,
        postStatusId: null,
        changeStatus: null,
    });

    const [selectedPostStatus, setSelectedPostStatus] = useState(null);
    const [selectedDriver, setSelectedDriver] = useState(null);
    const [selectedChangeStatus, setSelectedChangeStatus] = useState(null);
    const [updateErrors, setUpdateErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);


    const validateForm = () => {
        const newUpdateErrors = {};

        setUpdateErrors(newUpdateErrors);

        return Object.keys(newUpdateErrors).length === 0;
    };


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isLoading) return;

        if (validateForm() && (selectedPostStatus || selectedDriver || selectedChangeStatus)) {
            try {
                setIsLoading(true);
                const postIds = posts.map((post) => post.id);

                const data = await PostService.updateMultiple({
                    postIds,
                    ...formValues
                });
                if (data.status === 200) {
                    setPopupMsg(data.data.message);
                    setPopupType('update');
                    setShowPopup(true);
                    handleClose({ isReaload: true });
                    setFormValues({
                        driverId: null,
                        postStatusId: null
                    });
                    setSelectedDriver(null);
                    setSelectedPostStatus(null);
                    setSelectedChangeStatus(null);
                }

                setUpdateErrors({});
            } catch (error) {
                if (error.response?.status === 400) {
                    const responseErrors = error.response.data || {};
                    const formattedErrors = {};

                    Object.keys(responseErrors).forEach((field) => {
                        formattedErrors[field] = responseErrors[field];
                    });

                    setUpdateErrors(formattedErrors);
                } else {
                    setPopupMsg(error.response.data.error);
                    setPopupType('error');
                    console.error("An unexpected error occurred:", error);
                    setUpdateErrors({ general: error.response.data.error });
                }
            } finally {
                setIsLoading(false);
            }
        }
    };

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            aria-hidden="false"
            aria-modal="true"
            open={open}
            onClose={handleClose}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box
                    component="form"
                    onSubmit={handleSubmit}
                    sx={{
                        position: 'absolute',
                        top: '40%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '40%',
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 4,
                    }}
                >
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between'
                    }}>
                        <Typography id="transition-modal-title" variant="h6" component="h2">
                            {t('updateSelectedPosts')}
                        </Typography>
                        <CloseOutlinedIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
                    </Box>

                    {updateType === 'driver' &&
                        <Box width={'100%'}>
                            <DriverDropdown
                                helperText={updateErrors.driver}
                                error={!!updateErrors.driver}
                                setFormValues={setFormValues}
                                isFilter={false}
                                selectedDriver={selectedDriver}
                                setSelectedDriver={setSelectedDriver}
                            />
                        </Box>
                    }

                    {updateType === 'postStatus' &&
                        <Box width={'100%'}>
                            <PostStatusDropdown
                                helperText={updateErrors.postStatus}
                                error={!!updateErrors.postStatus}
                                setFormValues={setFormValues}
                                isFilter={false}
                                selectedPostStatus={selectedPostStatus}
                                setSelectedPostStatus={setSelectedPostStatus}
                                byPassInitial={true}
                            />
                        </Box>
                    }


                    {
                        (type === 'change' &&
                            updateType === "changeStatus") &&
                        <Box width={'100%'}>
                            <ChangeStatusDropdown
                                setFormValues={setFormValues}
                                isFilter={false}
                                selectedChangeStatus={selectedChangeStatus}
                                setSelectedChangeStatus={setSelectedChangeStatus}
                                byPassInitial={true}
                                doNotSelectDefault={true}
                            />
                        </Box>
                    }

                    {updateErrors.general && (
                        <Typography align="center" color="error" variant="body2" sx={{ mt: 2 }}>
                            {updateErrors.general}
                        </Typography>
                    )}

                    <Box sx={{
                        display: 'flex', justifyContent: 'center', alignItems: 'center',
                        mt: updateErrors.general ? 2 : 4
                    }}>
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            sx={{ textTransform: 'none', width: 140, height: 40 }}
                        >
                            {isLoading ? <CircularProgress color="secondary" size={28} /> :
                                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                    <p>{t('update')}</p>
                                    <DriveFileRenameOutlineOutlinedIcon fontSize="small" sx={{ mx: 0.4 }} />
                                </Box>
                            }
                        </Button>
                    </Box>
                </Box>
            </Fade>
        </Modal>
    );
}

export default UpdateMultiplePostModal;
